module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12QO8Vf/tc-custom/9781607051671.jpg?1709193212931",
      "alt": "This image is the cover for the book Beautiful Botanicals"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beautiful Botanicals\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“A wonderful way to bring more beauty into your life . . . sophisticated floral appliqué projects, varying in size from pillows to quilts.” —"), _c('i', [_vm._v("The Professional Quilter Magazine")])]), _c('br'), _c('br'), _vm._v("Plant an indoor garden with a bounty of lyrical appliqué designs. All the project patterns are interchangeable, so you can create endless combinations of flowers and leaves. See how color-saturated cottons, vibrant silks, and tone-on-tone chintzes breathe new life into botanical appliqué."), _c('br'), _c('br'), _vm._v("• 14 sophisticated floral appliqué projects include pillows, table runners, and small tapestry-style quilts and wall hangings"), _c('br'), _c('br'), _vm._v("• Full-size templates for 45 appliqué flowers, 2 butterflies, and 5 borders"), _c('br'), _c('br'), _vm._v("• Stitch up the projects as shown, or mix-and-match patterns to create your own masterpiece\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Deborah Kemball\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Deborah Kemball Bio: Deborah Kemball has been designing and making original, award-winning appliqué quilts since 2005. She lives with her husband and four sons in Montreal, Canada, where the long winters give her the perfect excuse for hibernating in her sewing studio. deborahkemball.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0